export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@views/profile/edit'),
    meta: {
      mastery: true,
      resourceOptional: true,
      secondaryRoute: true,
    },
  },
];
